import { getTimeZoneByGeoLocation } from 'async-timing';
import type { AddressType } from 'application-types';

export function getBrowserTimeZone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export function getChannelTimezone(
  address: Pick<AddressType, 'geo'>
): string | null {
  if (!address.geo) {
    return null;
  }

  const [longitude, latitude] = address.geo;

  return getTimeZoneByGeoLocation({ longitude, latitude });
}
